// extracted by mini-css-extract-plugin
export default {"registrationButton":"vPQEY9","disabled":"zFoord","primary":"YGXEUi","secondary":"MfcLBU","link":"RLfKjV","narrowerButton":"SmxfDk"};